import React from "react";
export function ForminatorTextarea(props) {
    var _a;
    const { placeholder, onChange, value, limit, limit_type, } = props;
    const onChangeValue = ({ target }) => {
        const intLimit = parseInt(limit);
        let currentVal = target.value;
        if (intLimit > 0) {
            let valLength;
            if (limit_type === 'characters') {
                valLength = target.value.length || 0;
                if (valLength > intLimit)
                    currentVal = currentVal.substring(0, intLimit);
            }
            else {
                const valSplit = (currentVal || '').split(' ');
                const valFiltered = valSplit.filter((w) => w !== '');
                valLength = valFiltered.length;
                if (valLength > limit) {
                    let wordCount = 0;
                    currentVal = valSplit.reduce((agr, curr) => {
                        if (wordCount < limit) {
                            wordCount++;
                            return agr + (curr || ' ') + (wordCount !== limit ? ' ' : '');
                        }
                        return agr;
                    }, '');
                }
            }
        }
        onChange(currentVal);
    };
    let count = limit_type === 'characters' ? ((value === null || value === void 0 ? void 0 : value.length) || 0) : (value || '').split(' ').filter((w) => w !== '').length;
    return React.createElement(React.Fragment, null,
        React.createElement("textarea", { style: { height: `${(_a = props['default-height']) !== null && _a !== void 0 ? _a : 140}px` }, value: value || '', placeholder: placeholder, onChange: onChangeValue, className: "ltg-control" }),
        limit && React.createElement("div", null,
            count,
            "/",
            limit));
}
